import { useApp, type Screen } from '../store';
import { btn, mono, head } from '../ui';

interface NavItem {
  key: Screen;
  label: string;
  badge: string;
}

export function Sidebar() {
  const app = useApp();
  const total = app.hosts.length;
  const online = app.hosts.filter(h => h.state !== 'offline').length;
  const onlineW = total ? Math.round((online / total) * 100) + '%' : '0%';

  const nav: NavItem[] = [
    { key: 'dash', label: 'Обзор', badge: '' },
    { key: 'fleet', label: 'Серверы', badge: String(total) },
    { key: 'commands', label: 'Команды', badge: '' },
    { key: 'files', label: 'Файлы', badge: '' },
    { key: 'rdp', label: 'RDP', badge: String(Math.min(app.selCount || app.rdpCount, app.rdpCount)) },
    { key: 'net', label: 'Сеть', badge: '' },
    { key: 'tasks', label: 'Задачи', badge: '' },
    { key: 'alerts', label: 'Алерты', badge: String(app.alerts.length) }
  ];

  return (
    <aside
      style={{
        width: 246,
        flex: 'none',
        position: 'sticky',
        top: 0,
        height: '100vh',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
        padding: '20px 14px',
        background: 'var(--panel)',
        borderRight: '1px solid var(--line)'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 11, padding: '4px 8px 18px' }}>
        <span
          style={{
            width: 30,
            height: 30,
            flex: 'none',
            borderRadius: 'var(--rs)',
            background: 'var(--acc)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...mono,
            fontSize: 13,
            fontWeight: 600,
            color: 'var(--accInk)'
          }}
        >
          F
        </span>
        <span style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.25 }}>
          <span style={{ fontWeight: 600, fontSize: 14, letterSpacing: '-0.01em' }}>Fleet Console</span>
          <span style={{ fontSize: 11, color: 'var(--ink3)' }}>{total} хостов Windows</span>
        </span>
      </div>

      {nav.map(item => {
        const on = app.screen === item.key || (item.key === 'fleet' && app.screen === 'detail');
        return (
          <button
            key={item.key}
            className="hov"
            onClick={() => app.go(item.key)}
            style={{
              ...btn,
              boxSizing: 'border-box',
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              padding: '9px 11px',
              borderRadius: 'var(--rs)',
              fontSize: 13,
              fontWeight: 500,
              color: on ? 'var(--ink)' : 'var(--ink2)',
              background: on ? 'var(--accSoft)' : 'transparent'
            }}
          >
            <span
              style={{
                width: 6,
                height: 6,
                borderRadius: '50%',
                flex: 'none',
                background: on ? 'var(--acc)' : 'var(--line2)'
              }}
            />
            <span style={{ flex: 1 }}>{item.label}</span>
            {item.badge ? (
              <span
                style={{
                  ...mono,
                  fontSize: 10.5,
                  padding: '1px 6px',
                  borderRadius: 99,
                  background: on ? 'var(--acc)' : 'var(--track)',
                  color: on ? 'var(--accInk)' : 'var(--ink3)'
                }}
              >
                {item.badge}
              </span>
            ) : null}
          </button>
        );
      })}

      <span style={{ flex: 1 }} />

      <div
        style={{
          border: '1px solid var(--line)',
          borderRadius: 'var(--r)',
          padding: 13,
          display: 'flex',
          flexDirection: 'column',
          gap: 9,
          background: 'var(--panel2)'
        }}
      >
        <span
          style={{
            fontSize: 11,
            color: 'var(--ink3)',
            letterSpacing: '.04em',
            textTransform: 'uppercase'
          }}
        >
          Агенты
        </span>
        <span style={{ display: 'flex', alignItems: 'baseline', gap: 7 }}>
          <span style={{ ...head, fontSize: 22, fontWeight: 700, letterSpacing: '-0.02em' }}>{online}</span>
          <span style={{ fontSize: 11.5, color: 'var(--ink3)' }}>на связи из {total}</span>
        </span>
        <span
          style={{
            display: 'flex',
            height: 5,
            borderRadius: 99,
            overflow: 'hidden',
            background: 'var(--track)'
          }}
        >
          <span style={{ display: 'block', height: 5, background: 'var(--ok)', width: onlineW }} />
        </span>
      </div>
    </aside>
  );
}
